import { ethers, formatUnits, parseUnits } from "ethers";
import { toastMessage } from "./toastMessage";
import { MESSAGE } from "constants/message";

// TRANSFER TOKEN
export const transferToken = async (
  walletProvider,
  contractAddress,
  ABI,
  to,
  amount
) => {
  try {
    const ethersProvider = new ethers.BrowserProvider(walletProvider);
    const signer = await ethersProvider.getSigner();
    const contract = new ethers.Contract(contractAddress, ABI, signer);
    const res = await contract.transfer(to, parseUnits(amount));
    return res?.hash;
  } catch (error) {
    const message = error.shortMessage ? error.shortMessage : error.message;
    toastMessage(`Transaction failed: ${message}`, MESSAGE.ERROR);
    throw new Error("Transaction failed: " + error.message);
  }
};

// APPROVE TOKEN
export const approveToken = async (
  walletProvider,
  contractAddress,
  ABI,
  to,
  amount,
  decimals
) => {
  try {
    const ethersProvider = new ethers.BrowserProvider(walletProvider);
    const signer = await ethersProvider.getSigner();
    const contract = new ethers.Contract(contractAddress, ABI, signer);
    const res = await contract.approve(
      to,
      parseUnits(amount.toString(), decimals)
    );
    await res.wait();
    return res?.hash;
  } catch (error) {
    console.log(error);

    const message = error.shortMessage ? error.shortMessage : error.message;
    toastMessage(`Transaction failed: ${message}`, MESSAGE.ERROR);
    throw new Error("Transaction failed: " + error.message);
  }
};

// ALLOWANCE TOKEN
export const allowanceToken = async (
  walletProvider,
  contractAddress,
  ABI,
  owner,
  spender,
  decimals
) => {
  try {
    const ethersProvider = new ethers.BrowserProvider(walletProvider);
    const signer = await ethersProvider.getSigner();
    const contract = new ethers.Contract(contractAddress, ABI, signer);
    const res = await contract.allowance(owner, spender);
    return parseFloat(formatUnits(res, decimals));
  } catch (error) {
    const message = error.shortMessage ? error.shortMessage : error.message;
    toastMessage(`Transaction failed: ${message}`, MESSAGE.ERROR);
    throw new Error("Transaction failed: " + error.message);
  }
};

// DEPOSIT TOKEN
export const depositToken = async (walletProvider, contractAddress, amount) => {
  try {
    const abi = [
      {
        inputs: [
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256",
          },
        ],
        name: "deposit",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
      },
    ];

    const ethersProvider = new ethers.BrowserProvider(walletProvider);
    const signer = await ethersProvider.getSigner();
    const contract = new ethers.Contract(contractAddress, abi, signer);
    const res = await contract.deposit(amount);
    // await res.wait();
    return res?.hash;
  } catch (error) {
    const message = error.shortMessage ? error.shortMessage : error.message;
    toastMessage(`Transaction failed: ${message}`, MESSAGE.ERROR);
    throw new Error("Transaction failed: " + error.message);
  }
};
// DEPOSIT COIN
export const depositCoin = async (walletProvider, contractAddress, amount) => {
  try {
    const abi = [
      {
        inputs: [],
        name: "deposit",
        outputs: [],
        stateMutability: "payable",
        type: "function",
      },
    ];

    const ethersProvider = new ethers.BrowserProvider(walletProvider);
    const signer = await ethersProvider.getSigner();
    const contract = new ethers.Contract(contractAddress, abi, signer);
    const res = await contract.deposit({ value: amount });
    // await res.wait();
    return res?.hash;
  } catch (error) {
    const message = error.shortMessage ? error.shortMessage : error.message;
    toastMessage(`Transaction failed: ${message}`, MESSAGE.ERROR);
    throw new Error("Transaction failed: " + error.message);
  }
};

// TRANSFER BNB
export const transferBNB = async (walletProvider, to, amount) => {
  try {
    const ethersProvider = new ethers.BrowserProvider(walletProvider);
    const signer = await ethersProvider.getSigner();
    const valueInEther = parseUnits(amount);
    const tx = await signer.sendTransaction({
      to,
      value: valueInEther,
    });
    return tx?.hash;
  } catch (error) {
    const message = error.shortMessage ? error.shortMessage : error.message;
    toastMessage(`Transaction failed: ${message}`, MESSAGE.ERROR);
    throw new Error("Transaction failed: " + error.message);
  }
};

// SWITCH NETWORK
export const switchNetwork = async ({
  walletProvider,
  chainID,
  chainName,
  rpcUrl,
  symbol,
  decimals,
  explorerUrl,
}) => {
  const chainIdHex = "0x" + chainID.toString(16);
  try {
    await walletProvider.request({
      method: "wallet_switchEthereumChain",
      params: [{ chainId: chainIdHex }],
    });
  } catch (switchError) {
    console.log(switchError);
    // alert(switchError.toString())
    try {
      await walletProvider.request({
        method: "wallet_addEthereumChain",
        params: [
          {
            chainId: chainIdHex,
            chainName: chainName,
            rpcUrls: [rpcUrl],
            nativeCurrency: {
              name: chainName,
              symbol: symbol,
              decimals: decimals,
            },
            blockExplorerUrls: [explorerUrl],
          },
        ],
      });
    } catch (addError) {
      // alert(addError.toString())
      console.error(addError);
    }
  }
};
